import makeStyles from "@material-ui/core/styles/makeStyles";

const useStyles = makeStyles({
  title: {
    margin: 0,
    lineHeight: 1.5,
    fontWeight: "bold",
    paddingLeft: 32,
  },
  table: {
    margin: 0,
  },
});

export default useStyles;
